module.exports = __webpack_public_path__ + "img/pro_one_4.a82add0d.jpg";